import { render, staticRenderFns } from "./addDistributionType.vue?vue&type=template&id=6b83934f&scoped=true&"
import script from "./addDistributionType.vue?vue&type=script&lang=js&"
export * from "./addDistributionType.vue?vue&type=script&lang=js&"
import style0 from "./addDistributionType.vue?vue&type=style&index=0&id=6b83934f&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b83934f",
  null
  
)

export default component.exports